export enum BlockchainWalletType {
  PROVIDER = 'provider',
  CUSTODY = 'custody',
}
